import React from 'react';
import { Phone, CalendarClock, SearchCheck, PhoneCall, Heart } from 'lucide-react';
export function Availability() {
  const cards = [{
    icon: Phone,
    title: 'Call First for Fastest Help',
    copy: 'Emergency auto glass searches are time-sensitive. Calling the Howell Auto Glass Service Center is the fastest way to check openings.'
  }, {
    icon: CalendarClock,
    title: 'Glass Availability Matters',
    copy: 'Some windshields and vehicle glass may be in stock or easier to source quickly. Specialty glass may take longer.'
  }, {
    icon: SearchCheck,
    title: 'We Confirm the Best Next Step',
    copy: 'The team will ask about your vehicle, damage, location and insurance details so they can recommend repair, replacement or inspection.'
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-833">
      <div className="max-w-7xl mx-auto" data-id="element-834">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-835">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-slate-900 mb-4 tracking-tight leading-tight" data-id="element-836">
            <span className="text-emergencyBrand-red" data-id="element-837">
              Same-Day Auto Glass Openings
            </span>{' '}
            May Be Available
          </h2>
          <p className="text-lg text-slate-600" data-id="element-838">
            Auto glass availability depends on your vehicle, the glass needed,
            insurance details and the day's schedule. Kosin's Glass will confirm
            the fastest available option when you call or submit the form.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8" data-id="element-839">
          {cards.map((card, i) => <div key={i} className="bg-white rounded-xl p-6 border border-slate-200 hover:border-emergencyBrand-red/40 hover:shadow-md transition-all" data-id="element-840">
              <div className="w-12 h-12 bg-emergencyBrand-redLight rounded-lg flex items-center justify-center mb-5" data-id="element-841">
                <card.icon className="w-6 h-6 text-emergencyBrand-red" data-id="element-842" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-843">
                {card.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-844">{card.copy}</p>
            </div>)}
        </div>
        {/* Trust callout */}
        <div className="bg-slate-50 border border-slate-200 rounded-xl p-5 sm:p-6 max-w-3xl mx-auto mb-10 flex items-start gap-4" data-id="element-845">
          <div className="bg-emergencyBrand-redLight p-2.5 rounded-lg shrink-0" data-id="element-846">
            <Heart className="w-5 h-5 text-emergencyBrand-red" data-id="element-847" />
          </div>
          <p className="text-slate-700 leading-relaxed" data-id="element-848">
            <span className="font-bold text-slate-900" data-id="element-849">
              Local drivers trust Kosin's Glass.
            </span>{' '}
            Urgent glass damage is stressful. Kosin's Glass helps you quickly
            understand glass availability, insurance options and the safest next
            step.
          </p>
        </div>
        <div className="text-center" data-id="element-850">
          <a href="tel:517-545-7772" className="inline-flex items-center justify-center gap-2 bg-emergencyBrand-red hover:bg-emergencyBrand-redHover text-white px-7 py-4 rounded-lg font-bold text-base transition-colors shadow-sm" data-id="element-851">
            <PhoneCall className="w-5 h-5" data-id="element-852" />
            Call 517-545-7772 to Check Availability
          </a>
        </div>
      </div>
    </section>;
}